function initAnimation() {
  gsap.fromTo('.cards__img--1',
    {
      y: 0,
    },
    {
      y: isTablet ? '-130%' : '-190%',
      ease: 'none',
      scrollTrigger: {
        trigger: '.section--cards',
        start: isTablet ? 'top+=150 bottom' : 'top 70% center',
        end: isTablet ? 'top 30% top' : 'bottom 30% top',
        scrub: true,
      }
    }
  );

  gsap.fromTo('.cards__imgs',
    {
      y: 0,
    },
    {
      y: isTablet ? '-10%' : '-50%',
      ease: 'none',
      scrollTrigger: {
        trigger: '.section--cards',
        start: isTablet ? 'top+=150 bottom' : 'top 70% center',
        end: 'bottom 30% top',
        scrub: true,
      }
    }
  );

  const box = document.querySelector(".cards__imgs");
  let els = box.querySelectorAll('div');
  const transforms = [
    {},
    {},
    {
      x: '-116%',
      y: 0,
      rotate: '-7deg',
      tablet: {
        x: '-87%',
        y: 0,
        rotate: '-7deg',
      }
    },
    {
      x: '20%',
      y: 0,
      rotate: '6.5deg',
    },
    {
      x: '-140%',
      y: '1rem',
      rotate: '-17deg',
    },
    {
      x: '65%',
      y: '1rem',
      rotate: '13deg',
    },
    {
      x: '18%',
      y: '-1.875rem',
      rotate: '33deg',
    },
    {
      x: '-105%',
      y: '-2.625rem',
      rotate: '-40deg',
    },
    {
      x: '-50%',
      y: '5rem',
      rotate: '45deg',
    }
  ];
  els.forEach((el, index) => {
    if (index < 2) {
      return;
    };
    let x = transforms[index]?.x || 0;
    let y = transforms[index]?.y || 0;
    let rotate = transforms[index]?.rotate;
    if (isTablet && transforms[index]?.tablet) {
      x = transforms[index]?.tablet.x || x;
      y = transforms[index]?.tablet.y || y;
      rotate = transforms[index]?.tablet.rotate || rotate;
    }

    gsap.fromTo(el, {x: '-50%', y: 0},{
      x: x,
      y: y,
      rotate: rotate,
      ease: 'none',
      scrollTrigger: {
        trigger: '.section--cards',
        end: isTablet ? '+=400' : '+=300',
        start: isTablet ? 'top 85% bottom' : 'top 35% center',
        scrub: true,
      },
    });

    
  });
  


  const bottomBox = document.querySelector(".cards-bot__imgs");
  if (!bottomBox) {
    return;
  }
  let bottomEls = bottomBox.querySelectorAll('div');
  bottomEls.forEach((img, index) => {
    let y = ((index + 1) * 70) + '%';
    let newY = '-30%';
    if (index=== bottomEls.length - 1) {
      y =  ((index + 1) * 30) + '%';
      newY = '0%';
    }
    if (isMobile) {
      y = ((index + 1) * 60) + '%';
      newY = '-10%';

      if (index === 3) {
        y = ((index + 1) * 80) + '%';
        newY = '-20%';
      } else if (index === 4) {
        y = ((index + 1) * 40) + '%';
        newY = '-20%';
      } else if (index === 5) {
        y =  '10%';
        newY = '-120%';
      } else if (index === 7) {
        y =  '300%';
        newY = '300%';
      }
    }
    gsap.fromTo(img,
      {
        y: y,
      },
      {
        y: newY,
        scrollTrigger: {
          trigger: '.section--cards-bot',
          start: 'top bottom',
          end: '+=200%',
          scrub: true,
        },
      })
  });
}

document.addEventListener('DOMContentLoaded', initAnimation);